import type { IconName } from "@/components/ui/icon";

export const NOTIFICATION_TAB_VALUES = ["all", "unread", "read"] as const;

export type NotificationTab = (typeof NOTIFICATION_TAB_VALUES)[number];

export interface NotificationTabItem {
  value: NotificationTab;
  label: string;
  icon: IconName;
}

export const NOTIFICATION_TAB_ITEMS: NotificationTabItem[] = [
  { value: "all", label: "All", icon: "IconTodos" },
  { value: "unread", label: "Unread", icon: "IconEyeClosed" },
  { value: "read", label: "Read", icon: "IconEyeOpen" },
];
